import axios from 'axios'

import {
  DRAFT_BASE_API_PATH,
  DRAFT_BASE_CACHE_MS,
  TA_DRAFT_API_BASE_PROD,
} from 'config/app.config'
import { inDevMode } from 'utils/dev'

let cached: { at: number; baseUrl: Promise<string> } | null = null

const requestDraftBaseUrl = async (): Promise<string> => {
  try {
    const res = await axios.get(DRAFT_BASE_API_PATH)
    const baseUrl = res.data?.baseUrl
    if (typeof baseUrl === 'string' && /^https?:\/\//.test(baseUrl)) return baseUrl
  } catch (error) {
    console.error('Could not find a local TA Draft; using the live one', error)
  }
  return TA_DRAFT_API_BASE_PROD
}

/**
 * Where TA Draft is.  In development the dev server looks through ports 3000-3003 for a local
 * TA Draft (`next dev` takes the first free one) and falls back to the live site; deployed,
 * it is always the live site.
 */
export const getDraftBaseUrl = async (): Promise<string> => {
  if (!inDevMode()) return TA_DRAFT_API_BASE_PROD

  const now = Date.now()
  if (cached && now - cached.at <= DRAFT_BASE_CACHE_MS) return await cached.baseUrl

  // Stored before it settles, so callers arriving together share the one request
  cached = { at: now, baseUrl: requestDraftBaseUrl() }
  return await cached.baseUrl
}
